import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from '../../../shared/svg-icon/svg-icon.component';

export interface MissingItem {
  uuid: string;
  name: string;
}

@Component({
  selector: 'app-missing-items-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      header="Hiányzó kötelező mellékletek"
      [visible]="visible"
      (visibleChange)="visibleChange.emit($event)"
      [modal]="true"
      [style]="{ width: '480px' }"
    >
      <div style="display: flex; flex-direction: column; gap: 1rem; padding: 0.5rem 0">
        @if (items.length > 0) {
          <p style="margin: 0; color: var(--fm-text-muted)">
            Az alábbi kötelező elemekhez nincs társított fájl. Kattintson egy elemre, hogy a
            mátrixban megjelenítse.
          </p>
          <ul class="missing-items-dialog__list">
            @for (item of items; track item.uuid) {
              <li class="missing-items-dialog__item" (click)="navigateToItem.emit(item.uuid)" title="Megjelenítés a mátrixban">
                <app-svg-icon name="warning-amber" [size]="18" />
                <span class="missing-items-dialog__name">{{ item.name }}</span>
                <app-svg-icon name="crosshair" [size]="16" class="missing-items-dialog__navigate-icon" />
              </li>
            }
          </ul>
        } @else {
          <p style="margin: 0; color: var(--fm-text-muted)">
            Van hiányzó kötelező melléklet, de a jelenlegi keresésnek egy sem felel meg. Törölje a
            keresést az összes hiányzó elem megtekintéséhez.
          </p>
        }
      </div>
      <ng-template pTemplate="footer">
        <p-button label="BEZÁRÁS" severity="secondary" [text]="true" (onClick)="visibleChange.emit(false)" />
      </ng-template>
    </p-dialog>
  `,
  styles: [
    `
      .missing-items-dialog__list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        max-height: 50vh;
        overflow-y: auto;
      }
      .missing-items-dialog__item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 0.75rem;
        border: 1px solid var(--fm-border, #e5e7eb);
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.15s;
      }
      .missing-items-dialog__item:hover {
        background: var(--fm-hover, #f3f4f6);
      }
      .missing-items-dialog__item:hover .missing-items-dialog__navigate-icon {
        opacity: 1;
      }
      .missing-items-dialog__name {
        font-weight: 500;
        flex: 1;
      }
      .missing-items-dialog__navigate-icon {
        opacity: 0;
        transition: opacity 0.15s;
        flex-shrink: 0;
      }
    `,
  ],
})
export class MissingItemsDialog {
  @Input() visible = false;
  @Input() items: MissingItem[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() navigateToItem = new EventEmitter<string>();
}
